<template>
  <div>
    <div :class="[!showDetails ? 'parent-2' : 'showOnlyDetail']">
      <v-card @click="showContacts">
        <v-card-title class="info-title">
          <div class="text-center">
            {{ category.N_Chart }}
          </div>
        </v-card-title>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["category", "index", "showDetails"],
  methods: {
    /**
     * user click on category
     */
    showContacts() {
      if (!this.showDetails) {
        this.$emit("clicked", this.index);
      }
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}
.showOnlyDetail {
  width: 100%;
}
</style>


